import LocalStorageService from '../../../services/local-storage-service';
import useMobileDevice from '../../../hooks/use-mobile-device';
import { TOGGLE_NAVIGATION_DRAWER } from '../../../constants/system/actions';

const navigationReducer: Reducer = (
  state: ReducerState = {
    isDrawerOpen: false,
  },
  action: ReduxAction,
): ReducerState => {
  let isNavigationDrawerOpen: boolean;

  const isMobileDevice: boolean = useMobileDevice();

  state.isDrawerOpen = LocalStorageService.hasFixedNavigationDrawerValue()
    ? LocalStorageService.getFixedNavigationDrawerValue() : !isMobileDevice;

  switch (action.type) {
    case TOGGLE_NAVIGATION_DRAWER:
      isNavigationDrawerOpen = !state.isDrawerOpen;

      LocalStorageService.setFixedNavigationDrawer(isNavigationDrawerOpen);

      return {
        ...state,
        isDrawerOpen: isNavigationDrawerOpen,
      };
    default:
      return state;
  }
};

export default navigationReducer;
